import { render, staticRenderFns } from "./SuggestionsList.vue?vue&type=template&id=6aefa047&scoped=true&"
import script from "./SuggestionsList.vue?vue&type=script&lang=js&"
export * from "./SuggestionsList.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionsList.vue?vue&type=style&index=0&id=6aefa047&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aefa047",
  null
  
)

export default component.exports